import React, { useCallback, useMemo } from 'react';

import { useSpotlight } from '../../spotlights';
import { ModalEntryPoint } from '../shared/modal-entry-point';

import { DIALOG_CONFIG } from './dialog-config';
import { entryPoint } from './entrypoint';

export function FeatureOnboardingModal() {
	const modalProps = useMemo(() => ({ width: 968, height: 568, autoFocus: false }), []);
	const { setActiveSpotlight } = useSpotlight();
	const isAutoOpened = false;

	const onClose = useCallback(
		// Have to mark as `unknown` to pass typescript requirements
		(tryNow?: unknown) => {
			if (tryNow) {
				// Don't show the spotlight if we're taking the customer to an action
				return;
			}

			if (isAutoOpened) {
				setActiveSpotlight('onboarding-available-after-dismiss');
			}
		},
		[setActiveSpotlight, isAutoOpened],
	);

	const entryPointProps = useMemo(() => ({ onClose, isAutoOpened }), [onClose, isAutoOpened]);

	return (
		<ModalEntryPoint
			entryPoint={entryPoint}
			modalProps={modalProps}
			dialogConfig={DIALOG_CONFIG}
			entryPointProps={entryPointProps}
		/>
	);
}
